module.exports = __webpack_public_path__ + "03_short_brown.c8783407.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/03_short_brown.png
// module id = k8qq
// module chunks = 0